<template>
  <div class="circ-num inlineblock" :class="botProp[1] + ' ' + botProp[2]" :aria-label="aria">
    <span class="always-white">{{botProp[0]}}</span>
  </div>
</template>

<script>
export default {
  props: {
    aria: {
      type: String,
      required: true
    },
    botProp: {
      type: Array,
      required: true
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/helpers/mixins";
.circ-num {
  width: 60px;
  height: 60px;
  padding-top: 0px;
  border-radius: 50%;
  font-size: 40px;
  color: white !important;
  text-align: center;
  background-color: white;
  margin: 5px;
  line-height: 1.5;
  &.circ-gran {
    width: 110px;
    height: 110px;
    padding-top: 24px;
    font-size: 60px;
    line-height: 1;
  }
  &.circ-peq {
    width: 40px;
    height: 40px;
    padding: 0 !important;
    font-size: 28px;
    line-height: 1.5;
  }
}
</style>


// WEBPACK FOOTER //
// CircleSpan.vue?1a345eaa